import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';
import {
  getApprovalByType,
  days,
  hasSign,
  renderDate,
  renderTime,
  renderDateTime,
  getDayIndexSignDate,
  renderSign, renderCustomInfo01
} from './utils/PtwCommonUtils.tsx';

interface IProps {
  formCode?: string;
  itemData?: any;
}

const View = (props: IProps) => {
  const approvalList = props.itemData?.approvalMVOList;
  const issuePerforming = getApprovalByType(approvalList, 'ISSUE', 1);
  const issueReviewing = getApprovalByType(approvalList, 'ISSUE', 2);
  const issueApproval = getApprovalByType(approvalList, 'ISSUE', 3);
  const issueCoordinator = getApprovalByType(approvalList, 'ISSUE', 4);
  const issueSiteVerification = getApprovalByType(approvalList, 'ISSUE', 5);
  const dailySubcontractorSv = getApprovalByType(approvalList, 'DAILY', 1);
  const dailySeaSv = getApprovalByType(approvalList, 'DAILY', 2);
  const closingCoordinator = getApprovalByType(approvalList, 'CLOSURE', 1);

  const todayDayIndex =
    getDayIndexSignDate(dailySubcontractorSv?.signCreateDate) !== -1
      ? getDayIndexSignDate(dailySubcontractorSv?.signCreateDate)
      : getDayIndexSignDate(dailySeaSv?.signCreateDate);

  return (
    <div>
      <table className={'preview-table preview-bottom-border'}>
        <colgroup>
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th rowSpan={3} className={'saf-border-bottom-none'}>
              ISSUE
              <br />
              (OPEN)
            </th>
            <th colSpan={2}>Signed Date</th>
            <th colSpan={2}>PERFORMING AUTHORITY</th>
            <th colSpan={2}>REVIEWING AUTHORITY</th>
            <th colSpan={2}>APPROVAL AUTHORITY</th>
          </tr>
          <tr>
            <th>DATE</th>
            <th>TIME</th>
            <th>DATE &amp; NAME</th>
            <th>SIGN</th>
            <th>DATE &amp; NAME</th>
            <th>SIGN</th>
            <th>DATE &amp; NAME</th>
            <th>SIGN</th>
          </tr>
          <tr>
            <td className="saf-td-center">
              &nbsp;
              {issueApproval?.signType ? renderDate(issueApproval) : ''}&nbsp;
            </td>
            <td className="saf-td-center">
              {issueApproval?.signType ? renderTime(issueApproval) : ''}
            </td>
            <td className="saf-td-center">
              {issuePerforming?.signType ? renderCustomInfo01(issuePerforming) : ''}
            </td>
            <td className="saf-td-center">{renderSign(issuePerforming)}</td>
            <td className="saf-td-center">
              {issueReviewing?.signType ? renderCustomInfo01(issueReviewing) : ''}
            </td>
            <td className="saf-td-center">{renderSign(issueReviewing)}</td>
            <td className="saf-td-center">
              {issueApproval?.signType ? renderCustomInfo01(issueApproval) : ''}
            </td>
            <td className="saf-td-center">{renderSign(issueApproval)}</td>
          </tr>
        </tbody>
      </table>
      <table className={'preview-table preview-bottom-border'}>
        <colgroup>
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th rowSpan={2}>Days</th>
            <th rowSpan={2}>Terms</th>
            <th colSpan={2}>Signed Date</th>
            <th colSpan={2}>Subcontractor SV</th>
            <th colSpan={2}>SE&A SV</th>
            <th rowSpan={2} style={{ backgroundColor: '#E2EFD9' }}>
              SE&A PTW Coordinator(OPEN)
            </th>
          </tr>
          <tr>
            <th>DATE</th>
            <th>TIME</th>
            <th>NAME</th>
            <th>SIGN</th>
            <th>NAME</th>
            <th>SIGN</th>
          </tr>
          {days.map((day) => {
            const visible = day.index === todayDayIndex;
            return (
              <Fragment key={day.label}>
                <tr>
                  <th className={'saf-bg-white'} rowSpan={2}>
                    {day.label}
                  </th>
                  <th>From</th>

                  <td className={'saf-td-center'}>
                    {visible && hasSign(dailySubcontractorSv)
                      ? renderDate(dailySubcontractorSv)
                      : ''}
                  </td>
                  <td className={'saf-td-center'}>
                    {visible && hasSign(dailySubcontractorSv)
                      ? renderTime(dailySubcontractorSv)
                      : ''}
                  </td>

                  <td className={'saf-td-center'} rowSpan={2}>
                    {visible && hasSign(dailySubcontractorSv)
                      ? dailySubcontractorSv.userNm
                      : ''}
                  </td>
                  <td className={'saf-td-center'} rowSpan={2}>
                    {visible ? renderSign(dailySubcontractorSv) : ''}
                  </td>

                  <td className={'saf-td-center'} rowSpan={2}>
                    {visible && hasSign(dailySeaSv) ? dailySeaSv.userNm : ''}
                  </td>
                  <td className={'saf-td-center'} rowSpan={2}>
                    {visible ? renderSign(dailySeaSv) : ''}
                  </td>

                  {day.index === 1 && (
                    <td className={'saf-td-center'} rowSpan={6}>
                      {renderSign(issueCoordinator, 'large')}
                    </td>
                  )}
                  {day.index === 4 && (
                    <th rowSpan={2} style={{ backgroundColor: '#FBE4D5' }}>
                      SE&A PTW Coordinator(CLOSE)
                    </th>
                  )}
                  {day.index === 5 && (
                    <td rowSpan={6} className={'saf-td-center'}>
                      {renderSign(closingCoordinator, 'large')}
                    </td>
                  )}
                </tr>

                <tr>
                  <th>To</th>
                  <td className={'saf-td-center'}>
                    {visible && hasSign(dailySeaSv) ? renderDate(dailySeaSv) : ''}
                  </td>
                  <td className={'saf-td-center'}>
                    {visible && hasSign(dailySeaSv) ? renderTime(dailySeaSv) : ''}
                  </td>
                </tr>
              </Fragment>
            );
          })}
        </tbody>
      </table>
      <table className={'preview-table saf-w60'}>
        <colgroup>
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th
              rowSpan={3}
              className={'saf-border-bottom-none'}
              style={{ backgroundColor: '#FFFF00' }}
            >
              SITE
              <br />
              Verification
            </th>
            <th rowSpan={2}>DATE & TIME</th>
            <th colSpan={2} className={'preview-right-border'}>
              SE&A Area Lead HSSE
            </th>
          </tr>
          <tr>
            <th>NAME</th>
            <th className={'preview-right-border'}>SIGN</th>
          </tr>
          <tr>
            <td className={'saf-td-center'}>
              {issueSiteVerification?.signType ? renderDateTime(issueSiteVerification) : ''}
            </td>
            <td className={'saf-td-center'}>
              {issueSiteVerification?.signType ? issueSiteVerification?.userNm : ''}
            </td>
            <td className={'preview-right-border saf-td-center'}>
              &nbsp;{renderSign(issueSiteVerification)}&nbsp;
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default View;
